import React from "react";
import { oneOfType, oneOf, arrayOf, shape, node, func, number, string, object } from "prop-types";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
import CustomTooltip from "../CustomTooltip";

import { connectToState } from "../../redux/connect-api";
import analytics from "shared/analytics";

import { SORTABLE_COLUMNS } from "../../config";

const TOOLTIP_FIELDS = ["date_of_review"];

class AnalysesTableHeaderCell extends React.PureComponent {
  handleSortClick = () => {
    const {
      fieldKey,
      actions: { setSort },
    } = this.props;
    const { sort: { sortField, sortDirection = "asc" } = {} } = this.props;
    // unless existing sortField is the same as fieldKey, sort by ascending:
    const nextSortDirection = fieldKey === sortField && sortDirection === "asc" ? "desc" : "asc";
    setSort(fieldKey, nextSortDirection, SORTABLE_COLUMNS[fieldKey] || "string");
    analytics.trackSort(fieldKey, nextSortDirection);
  };

  renderLabel = () => {
    const { fieldKey, children, tooltip } = this.props;
    const isSortable = fieldKey && Object.keys(SORTABLE_COLUMNS).includes(fieldKey);
    let content = children;
    if (TOOLTIP_FIELDS.includes(fieldKey)) {
      content = <CustomTooltip id={fieldKey} content={children} title={tooltip} />;
    }
    if (isSortable) {
      const { sort: { sortField, sortDirection = "asc" } = {} } = this.props;
      const active = fieldKey === sortField;
      const thisTabSortDirection = active ? sortDirection : "asc";
      // <small>({thisTabSortDirection})</small>
      return (
        <TableSortLabel
          active={active}
          direction={thisTabSortDirection}
          onClick={this.handleSortClick}
          sx={{
            "&:focus": {
              "& .MuiTableSortLabel-icon": {
                opacity: 1,
              },
            },
          }}
        >
          {content}
        </TableSortLabel>
      );
    }
    return content;
  };

  render() {
    const {
      rowSpan,
      colSpan,
      className,
      align,
      sx,
      fieldKey,
      sort: { sortField, sortDirection = "asc" } = {},
    } = this.props;

    return (
      <TableCell
        rowSpan={rowSpan}
        colSpan={colSpan}
        onClick={this.handleMouseClick}
        className={className}
        component="th"
        align={align}
        sortDirection={fieldKey === sortField ? sortDirection : false}
        sx={sx}
      >
        {this.renderLabel()}
      </TableCell>
    );
  }
}

AnalysesTableHeaderCell.defaultProps = {
  colSpan: 1,
  rowSpan: 1,
  fieldKey: null,
  children: null,
  sx: undefined,
};

AnalysesTableHeaderCell.propTypes = {
  colSpan: number,
  rowSpan: number,
  fieldKey: string,
  className: string.isRequired,
  align: string.isRequired,
  sx: oneOfType([object, func]),
  sort: shape({
    sortField: oneOf(Object.keys(SORTABLE_COLUMNS)),
    sortDirection: oneOf(["asc", "desc"]),
  }),
  actions: shape({
    setSort: func.isRequired,
  }).isRequired,
  children: oneOfType([arrayOf(node), node]),
  tooltip: node,
};

const mapStateToProps = (state) => ({
  sort: state.sort,
});

export default connectToState(mapStateToProps)(AnalysesTableHeaderCell);
